import React, { useEffect, useState } from "react";
import { getAllPartnerPromoCodeApi, addPartnerPromoCodeApi } from "../../http/affiliateAPI";
import {Form, Button, Spinner, Table, Card} from "react-bootstrap";
import { toast } from "react-toastify";
import Row from "react-bootstrap/Row";

const AdminPartnerPromoCodes = () => {
    const [requests, setRequests] = useState([]);
    const [savingId, setSavingId] = useState(null);

    const discountOptions = [10, 15, 20, 25, 30, 35, 40, 45, 50];
    const codeTypeOptions = [
        { value: "One_Month", label: "1 Month" },
        { value: "Three_Months", label: "3 Months" },
        { value: "Six_Months", label: "6 Months" },
        { value: "One_Year", label: "1 Year" },
        { value: "Forever", label: "Forever" }
    ];
    const validUntilOptions = [
        { value: 1, label: "1 Month from now" },
        { value: 3, label: "3 Months from now" },
        { value: 6, label: "6 Months from now" },
        { value: 12, label: "1 Year from now" },
        { value: 36, label: "3 Years from now" }
    ];

    const fetchData = async () => {
        try {
            const data = await getAllPartnerPromoCodeApi();
            setRequests(data);
            toast.success("Data loaded", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
        } catch (e) {
            toast.error("Failed to load promo code requests.", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
        }
    };

    const resetData = async () => {
       setRequests([]);
    };



    const handleChange = (index, field, value) => {
        let formattedValue = value;

        if (field === "code") {
            formattedValue = value
                .toUpperCase()
                .replace(/[^A-Z0-9]/g, ''); // только латиница и цифры
        }

        if (field === "coupon_id" || field === "coupon_name") {
            formattedValue = value.trim();
        }

        setRequests((prev) =>
            prev.map((item, i) =>
                i === index ? { ...item, [field]: formattedValue } : item
            )
        );
    };

    const handleSave = async (req) => {
        setSavingId(req.id);
        try {
            const payload = {
                order_id: req.id,
                code: req.code,
                coupon_id: req.coupon_id,
                coupon_name: req.coupon_name,
                discount_percent: Number(req.discount_percent),
                valid_until: req.valid_until,
                code_type: req.code_type,
                approval_date: req.approval_date,
                order_status: req.order_status,
                admin_comment: req.admin_comment,
            };
            const response = await addPartnerPromoCodeApi(payload);
            toast.success(response.message || "Saved successfully!", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
        } catch (e) {
        const errorMessage =
            e?.response?.data?.message || e?.message || "Failed to save.";
        toast.error(errorMessage, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
    } finally {
            setSavingId(null);
        }
    };

    return (
        <Card className="shadow-sm bg-light p-0">
            <Card.Body>
                {/* Фильтры */}
                <Row className="mb-0">
        <div className="table-responsive">

            <Button
                variant="success"
                size="sm"
                className="mb-2"
                onClick={fetchData}
            >
                Get Data
            </Button>
            <Button
                variant="outline-success"
                size="sm"
                className="mb-2 ms-3"
                onClick={resetData}
            >
                Reset
            </Button>
            {requests.length > 0 && (
         <>
            <h6 className="mb-2 text-muted small">Promo Code Requests (Admin Panel)</h6>
            <div style={{ overflowX: 'auto', whiteSpace: 'nowrap', paddingBottom: '10px' }}>
                <Table striped bordered hover size="sm" className="small" style={{ minWidth: '1200px' }}>
                <thead className="text-muted">
                <tr className="align-middle small">
                    <th className="text-muted">UID</th>
                     <th className="text-muted">Desired</th>
                     <th className="text-muted">CoupID</th>
                     <th className="text-muted">Coupon Name</th>
                     <th className="text-muted">Code</th>
                     <th className="text-muted">%</th>
                     <th className="text-muted">Type</th>
                     <th className="text-muted">Valid Until</th>
                     <th className="text-muted">Order Status</th>
                     <th className="text-muted">Promo Status</th>
                     <th className="text-muted">Req. Comment</th>
                     <th className="text-muted">Admin Comment</th>
                     <th className="text-muted">Actions</th>
                </tr>
                </thead>
                <tbody>
                {requests.map((req, i) => (
                    <tr key={req.id} className="align-middle small">
                        <td>{req.user_id}</td>
                        <td>{req.desired_code}</td>
                        <td>
                            <Form.Control
                                size="sm"
                                className="form-control-sm"
                                value={req.coupon_id || ""}
                                onChange={(e) => handleChange(i, "coupon_id", e.target.value)}
                            />
                        </td>
                        <td>
                            <Form.Control
                                size="sm"
                                className="form-control-sm"
                                value={req.coupon_name || ""}
                                onChange={(e) => handleChange(i, "coupon_name", e.target.value)}
                            />
                        </td>
                        <td>
                            <Form.Control
                                size="sm"
                                className="form-control-sm"
                                value={req.code || ""}
                                onChange={(e) => handleChange(i, "code", e.target.value)}
                            />
                        </td>
                        <td>
                            <Form.Select
                                size="sm"
                                className="form-select-sm"
                                value={req.discount_percent}
                                onChange={(e) => handleChange(i, "discount_percent", e.target.value)}
                            >
                                {discountOptions.map((val) => (
                                    <option key={val} value={val}>{val}%</option>
                                ))}
                            </Form.Select>
                        </td>
                        <td>
                            <Form.Select
                                size="sm"
                                className="form-select-sm"
                                value={req.code_type || ""}
                                onChange={(e) => handleChange(i, "code_type", e.target.value)}
                            >
                                {codeTypeOptions.map((opt) => (
                                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                                ))}
                            </Form.Select>
                        </td>
                        <td>
                            <Form.Control
                                size="sm"
                                className="form-control-sm"
                                type="date"
                                value={req.valid_until?.slice(0, 10) || ""}
                                onChange={(e) => handleChange(i, "valid_until", e.target.value + "T23:59:59.000Z")}
                            />
                        </td>
                        <td>
                            <Form.Select
                                size="sm"
                                className="form-select-sm"
                                value={req.order_status}
                                onChange={(e) => handleChange(i, "order_status", e.target.value)}
                            >
                                <option value="pending">pending</option>
                                <option value="approved">approved</option>
                                <option value="rejected">rejected</option>
                            </Form.Select>
                        </td>
                        <td className="text-muted">{req.promo_code_status}</td>
                        <td className="text-muted">{req.request_comment}</td>
                        <td>
                            <Form.Control
                                size="sm"
                                className="form-control-sm"
                                value={req.admin_comment || ""}
                                onChange={(e) => handleChange(i, "admin_comment", e.target.value)}
                            />
                        </td>
                        <td>
                            <Button
                                variant="success"
                                size="sm"
                                className="btn-sm"
                                disabled={savingId === req.id}
                                onClick={() => handleSave(req)}
                            >
                                {savingId === req.id ? <Spinner size="sm" animation="border" /> : "Save"}
                            </Button>
                        </td>
                    </tr>
                ))}
                </tbody>
            </Table>
            </div>
           </> )}
        </div>
        </Row>
            </Card.Body>
        </Card>

    );
};

export default AdminPartnerPromoCodes;
